export default __webpack_public_path__ + "static/media/icon_menu_support_hover.6c0d4395.svg";